import React from "react";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import DocsSearch from "./DocsSearch";


const DocsHeader = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-[#eaeaea] bg-white/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-6">
        {/* Left: Logo & Nav */}
        <div className="flex items-center gap-8">
          <Link to="/dashboard" className="flex items-center gap-2 group">
            <div className="h-8 w-8 rounded bg-black flex items-center justify-center text-white font-bold text-lg group-hover:scale-110 transition-transform">
              C
            </div>
            <span className="text-sm font-bold tracking-tight text-black">Capture The Bug Docs</span>
          </Link>
          
          <nav className="hidden items-center gap-6 lg:flex">
            {/* <a href="#" className="text-sm font-medium text-slate-600 hover:text-black transition-colors">Showcase</a>
            <a href="#" className="text-sm font-medium text-slate-600 hover:text-black transition-colors">Resources</a> */}
          </nav>
        </div>

        {/* Center: Search */}
        <div className="hidden flex-1 max-w-md mx-8 md:block">
          <DocsSearch />
        </div>


        {/* Right: Social & Mobile Menu */}
        <div className="flex items-center gap-6">
          <a 
            href="https://capturethebug.xyz" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-sm font-bold text-slate-600 hover:text-black transition-colors"
          >
            Website
          </a>

          <Link 
            to="/dashboard/onboarding-documentation#interactive-tour" 
            className="text-sm font-bold text-slate-600 hover:text-black transition-colors"
          >
            Interactive Tour
          </Link>
          
          {/* <a 
            href="https://app.capturethebug.xyz" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hidden sm:flex items-center gap-2 px-4 py-2 bg-black text-white rounded-xl text-xs font-black hover:bg-slate-800 transition-all shadow-lg shadow-black/10 active:scale-95"
          >
            Go to Dashboard
          </a> */}

          <button className="lg:hidden text-slate-600">
            <FiMenu className="h-6 w-6" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default DocsHeader;
